import { Component, OnInit } from '@angular/core';
import { FeedbackService } from 'src/app/services/feedback.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { ToolsService } from 'src/app/services/tools.service';
import { Store } from 'src/app/store';

@Component({
    selector: 'app-feedback-report',
    templateUrl: './feedback-report.component.html',
    styleUrls: ['./feedback-report.component.css']
})
export class FeedbackReportComponent implements OnInit {

    data = undefined;
    businesses = [];
    templates = [];
    questions = {
        thumbs: [],
        choice: [],
    };

    dateStart = undefined;
    dateEnd = undefined;

    params: any = {
        business: undefined,
        template: undefined,
        questions: {
            thumbs: [],
            choice: [],
        },
        summary: undefined,
        exclusion: '',
        dateStart: undefined,
        dateEnd: undefined,
    }

    constructor(
        private feedbackService: FeedbackService,
        private toolsService: ToolsService,
        private store: Store,
        private overlayService: OverlayService,
    ) { }

    ngOnInit(): void {
    }


    getBusinesses() {
        this.feedbackService.getBusinesses().subscribe(data => {
            console.log(data);
            this.businesses = data;
        })
    }

    updateDates() {
        if (this.dateStart) {
            this.params.dateStart = this.toolsService.buildDateString(this.dateStart);
        }
        if (this.dateEnd) {
            this.params.dateEnd = this.toolsService.buildDateString(this.dateEnd);
        }

        if (this.dateStart && this.dateEnd) {
            this.getBusinesses();
        }
    }


    selectBusiness(v: number) {
        this.templates = [];
        this.questions.thumbs = [];
        this.questions.choice = [];

        this.params.template = undefined;
        this.params.questions.thumbs = [];
        this.params.questions.choice = [];

        this.params.business = v;
        this.feedbackService.getBusinessTemplates(v).subscribe(data => {
            console.log(data);
            this.templates = data;
        })
    }

    selectTemplate(v: number) {
        this.questions.thumbs = [];
        this.questions.choice = [];
        this.params.questions.thumbs = [];
        this.params.questions.choice = [];

        this.params.template = v;
        this.feedbackService.getTemplateQuestions(v).subscribe(data => {
            console.log(data);
            this.questions.thumbs = data.thumbs;
            this.questions.choice = data.choice;
        })
    }

    selectSummary(v: number) {
        this.params.exclusion = '';
        if (this.params.summary && this.params.summary === v) {
            this.params.summary = undefined;
        } else {
            this.params.summary = v;
        }
    }

    selectQuestion(v: number, arr: string) {

        if (this.questionSelected(v, arr)) {
            this.params.questions[arr].splice(this.params.questions[arr].indexOf(v), 1);
        } else {
            this.params.questions[arr].push(v);
        }
    }

    questionSelected(v: number, arr: string) {
        console.log(this.params.questions)
        return this.params.questions[arr].indexOf(v) > -1;
    }
    setExclusion(p: string) {
        if (this.params.exclusion === p) {
            this.params.exclusion = '';
        } else {
            this.params.exclusion = p;
        }
    }
    submit() {
        this.overlayService.setProcessing({ open: true, title: 'Building report data....' })

        this.data = undefined;
        this.feedbackService.reportData(this.params).subscribe(data => {

            this.data = data.data;
            this.overlayService.setProcessing({ open: false, title: '' })
            console.log(data.data)
        })
    }

    close() {
        this.data = undefined;
    }

}
